module.exports = __webpack_public_path__ + "img/loading.a2494c9f.png";